import { IsNotEmpty, IsString } from 'class-validator';

export class OrderDialogManageSessionRequestDto {
  @IsNotEmpty()
  @IsString()
  clientId: string;
}